<template>
  <label @click="event=>{if(!disabled){$emit('click',event)}}">
    <el-form :disabled="disabled" style="display: inline-block;">
      <slot />
    </el-form>
  </label>
</template>

<script>
export default {
  name: 'CargoButtonContainer',
  props: {
    disabled: { type: Boolean, default: false }
  }
}
</script>

<style>
</style>
